import { Box } from "@mui/system"
import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    orderContainer: {
        padding: "0 2rem",
    },
    title: {
        fontWeight: 500,
        color: theme.palette.tailwind.slate[700],

        [theme.breakpoints.down("sm")]: {
            textAlign: "center",
            fontSize: theme.typography.h5.fontSize,
            lineHeight: 1.2,
            fontWeight: 700,
        },
    },
    errorDetails: {
        marginTop: "2rem",
    },
    errorTitle: {
        fontWeight: 600,
        marginBottom: "1rem",
    },
}))

export function ErrorFallback({
    orderId,
    message,
    title,
}: {
    orderId: number
    message?: string
    title?: string | null
}) {
    const { classes, cx } = useStyles()

    return (
        <Box className={cx(classes.orderContainer)}>
            <Box className={classes.errorDetails}>
                {title !== null &&
                    (title ? (
                        <Typography variant="h5" className={classes.errorTitle}>
                            {title}
                        </Typography>
                    ) : (
                        <LocalizedStrict id="receipt-purchase-receipt-error" vars={{ orderId: orderId.toString() }}>
                            <Typography variant="h5" className={classes.errorTitle}>
                                Failed to load receipt with id #{orderId.toString()}
                            </Typography>
                        </LocalizedStrict>
                    ))}
                {message ? (
                    <Typography variant="body1">{message}</Typography>
                ) : (
                    <LocalizedStrict id="receipt-purchase-receipt-error-description">
                        <Typography variant="body1">
                            This order could not be processed due to missing or invalid data.
                        </Typography>
                    </LocalizedStrict>
                )}
            </Box>
        </Box>
    )
}

